import { globalConfig } from '../../../config/globalConfig';
import { api } from '../../../config/api';
import { BaseActions } from './baseActions';
import { Oktmo, OktmoDTO, OktmoType } from '../models/oktmo';
import { OktmoListParams } from '../interfaces/OktmoListParams';
import { CollectionDTOInterface } from '@thewhite/react-global-module/lib/interfaces';

export class OktmoActions extends BaseActions {
    static DEFAULT_URL = `${globalConfig.api}/oktmo-service/oktmos/`;
    static api         = api;

    /**
     * Получить список населённых пунктов
     * @param queryParams
     */
    static list = (queryParams: OktmoListParams): Promise<CollectionDTOInterface<Oktmo>> => {
        return OktmoActions.COLLECTION_API_RESOURCE<OktmoDTO, Oktmo>({
            queryParams,
            model: Oktmo,
            url: 'list/page',
            modelType: OktmoType,
        });
    };

    /**
     * Получить населённый пункт по идентификатору
     * @param id
     */
    static get = (id: string): Promise<Oktmo | null> => {
        return OktmoActions.MODEL_API_RESOURCE<OktmoDTO, Oktmo>({
            url: id,
            model: Oktmo,
            modelType: OktmoType,
        });
    };

    /**
     * Получение списка октмо по id
     */
    static listByIds(ids: string[]) {
        return OktmoActions.COLLECTION_API_RESOURCE<OktmoDTO, Oktmo>({
            queryParams: { ids },
            model: Oktmo,
            url: 'list/by-ids',
            modelType: OktmoType,
        });
    }
}
